import React, { createContext, ReactNode, useContext } from "react";
import { InstallationData } from "@/installation/installation";

type HighlightAssetContextType = {
  assetToHighlight?: InstallationData
};

const HighlightAssetContext = createContext<HighlightAssetContextType | undefined>(undefined);

export function HighlightAssetContextProvider({ children, assetToHighlight }: { children: ReactNode, assetToHighlight?: InstallationData }) {

  return (
    <HighlightAssetContext.Provider
      value={{
        assetToHighlight
      }}
    >
      {children}
    </HighlightAssetContext.Provider>
  );
}

export function useHighlightAsset() {
  return useContext(HighlightAssetContext);
}
